import { useAuth } from '@/shared/hooks/useAuth';

const EDIT_ROLES = new Set(['manager', 'admin', 'owner', 'agency_admin']);

/** Mirrors the backend's `authorize('manager', 'admin', 'owner')` on the action
 *  routes, so viewers don't see controls that would only 403. */
export function useCanEdit(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.isAgency || EDIT_ROLES.has(user.role ?? '');
}
